/* import __COLOCATED_TEMPLATE__ from './nav.hbs'; */
import { classNames } from '@ember-decorators/component';
import Component from '@ember/component';
import classic from 'ember-classic-decorator';
import styles from './nav.module.scss';

@classic
@classNames('pw-nav', styles.component)
export default class PracticeWebsiteNav extends Component {}
